// extracted by mini-css-extract-plugin
export default {"root":"root--I4Y0ZBtBv20NXZQ","icon":"icon--icpAqP0Seh3tTde"};